import generateContextHook from 'onyx-common/generateContextHook'
import ctx from './context'

export default generateContextHook(ctx)
